import { StrictMode, ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Conditional wrapper for StrictMode
const ConditionalStrictMode = ({ children }: { children: ReactNode }) => {
  // Enable StrictMode in development when:
  // 1. Environment variable is set to 'true', OR
  // 2. URL contains '?strict=true'
  const enableStrictMode = import.meta.env.DEV && (
    import.meta.env.VITE_ENABLE_STRICT_MODE === 'true' ||
    new URLSearchParams(window.location.search).get('strict') === 'true'
  );
  
  return enableStrictMode ? (
    <StrictMode>{children}</StrictMode>
  ) : (
    <>{children}</>
  );
};

createRoot(document.getElementById('root')!).render(
  <ConditionalStrictMode>
    <App />
  </ConditionalStrictMode>,
)
